import { useState } from "react";
import './ResourceListMessage.scss'
function ResourceListMessage({ onClose }) {
  const [show, setShow] = useState(true);

  const closeMessage = () => {
    setShow(false);
    if (onClose) onClose();
  };

  if (!show) return null;

  return (
    <div className="message-wrapper">
      <div className="message-content">
        <img
          className="common-error-icon"
          src={`${process.env.PUBLIC_URL}/images/step2Error-icon.svg`}
          alt="info"
        />
        <span className="text-section">
          Please complete all required fields before generating access codes
        </span>
      
      <button onClick={closeMessage} className="close-button">
        <img
          src={`${process.env.PUBLIC_URL}/images/incorrect.svg`}
          alt="close"
        />
      </button>
    </div>
    </div>
  );
}

export default ResourceListMessage;
